import React, { Component } from 'react';
import '../App.css';
import soleIcon from '../assets/fintwist-favicon.png';
import {Link} from 'react-router-dom';

class Nav extends Component {
  render() {
    return (
      <div className="nav-container">
        <Link to='/' className="nav-home-contain">
          <i className="fa fa-home"></i>
          <p>home</p>
        </Link>
        <Link to="/"><img src={soleIcon} alt="" /></Link>
        <Link to={'/contact'}><button>request info <i className="fa fa-arrow-right"></i></button></Link>
      </div>
    );
  }
}

export default Nav;
